const initialState = {
  isQrRead: false,
  unableActionsRelatedToCompanies: false,
  relation: null,
  alreadyRedirect: false,
  showLoginModal: false,

  //Table data
  tableId: null,
  tableName: null,
  table: null,

  //Company data
  sysCompanyId: null,
  foodStallId: null,
  companyName: null,
  foodStallName: null,
  currency: 'MXN',
  attentionType: null,
  typeOfClientAccess: null,
  clientPermissions: {},
  logoUrl: null,
  foodStallLogoUrl: null,
  advertisingImage: null,
  foodStallAdvertisingImage: null,
  mapUrl: null,
  foodStallMapUrl: null,
  generalParameters: {},
  services: [],
  ChildCompanies: [],
  company: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_IS_QR_READ": {
      return {
        ...state,
        isQrRead: true,
      };
    }
    case "LOAD_COMAPANY_INFO": {
      return {
        ...state,
        company: payload,
        foodStallId: null,
        foodStallName: null,
        foodStallLogoUrl: null,
        foodStallAdvertisingImage: null,
        foodStallMapUrl: null,
        sysCompanyId: payload.id,
        companyName: payload?.name,
        currency: payload?.currency,
        attentionType: payload?.attention_type,
        typeOfClientAccess: payload?.type_of_client_access,
        logoUrl: payload?.ExtraData?.logo_url,
        advertisingImage: payload?.ExtraData?.advertising_image,
        clientPermissions: payload?.clientPermissions,
        generalParameters: payload?.GeneralParameters,
        ChildCompanies: payload?.ChildCompanies,
        tableName: null,
      };
    }
    case "LOAD_FODD_STALL_INFO": {
      return {
        ...state,
        company: payload,
        foodStallId: payload?.id,
        foodStallName: payload?.name,
        currency: payload?.currency,
        typeOfClientAccess: payload?.type_of_client_access,
        foodStallLogoUrl: payload?.ExtraData?.logo_url,
        foodStallAdvertisingImage: payload?.ExtraData?.advertising_image,
        foodStallMapUrl: payload?.ExtraData?.map_url,
        clientPermissions: payload?.clientPermissions,
        generalParameters: {
          //show_products_foodStall es un valor que solo cambia por el fatherSysCompany
          ...payload?.GeneralParameters,
          show_products_foodStall:
            state.generalParameters?.show_products_foodStall ??
            payload?.GeneralParameters?.show_products_foodStall,
          parking_payment_url:
            state.generalParameters?.parking_payment_url ??
            payload?.GeneralParameters?.parking_payment_url,
        },
        redirectionFlag: !state.redirectionFlag,
        productId: payload?.productId,
        services: payload?.services,
      };
    }
    case "TABLE_INFO": {
      return {
        ...state,
        tableId: payload.id,
        sysCompanyId: payload?.sys_company_id,
        tableName: payload.name,
        table: payload,
      };
    }
    case "SET_UNREAD_QR": {
      return {
        initialState,
      };
    }
    case "SET_SYS_COMPANY_STRIPE_KEYS": {
      return {
        ...state,
        stripe_public_key: action.payload.stripe_public_key,
        stripe_secret_key: action.payload.stripe_secret_key,
      };
    }
    case "SET_LOGIN_MODAL": {
      return {
        ...state,
        showLoginModal: !!payload,
      };
    }
    case "RESET": {
      return initialState;
    }
    case "LOGOUT": {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
